import logoimg from '../../assets/logo-v2.png';
import logoimgMobile from '../../assets/logo-mobile.png';
import notFoundImg from '../../assets/404-illustration.png';

/**
 * Asset-backed constants, owned by the web app.
 *
 * These cannot live in @tenant/core: an imported image resolves to a URL string
 * under webpack and to a numeric `require()` handle under Metro, so the value
 * is inherently platform-specific. The native app declares its own equivalents
 * against its own bundled assets.
 */

/**
 * Default app logo. Typically displayed in header
 *
 * @type {string}
 */
export const DEFAULT_LOGO = logoimg;

/**
 * Default app logo for mobile devices. Typically displayed in header
 *
 * @type {string}
 */
export const DEFAULT_LOGO_MOBILE = logoimgMobile;

/**
 * Default image to display on 404 page
 *
 * @type {string}
 */
export const DEFAULT_404_IMG = notFoundImg;
